import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f0f10] text-white flex items-center justify-center px-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#e63946]/15 mb-4">
            <Lock className="w-5 h-5 text-[#e63946]" />
          </div>
          <h1 className="text-2xl font-bold uppercase tracking-wide" style={{ fontFamily: 'Oswald, sans-serif' }}>Admin Login</h1>
          <p className="text-gray-500 text-sm mt-1">Corner Office Curmudgeon</p>
        </div>
        <form onSubmit={submit} className="space-y-4 bg-[#161618] border border-[#26262a] rounded-xl p-6">
          <div>
            <Label htmlFor="username" className="text-gray-300">Username</Label>
            <Input id="username" value={username} onChange={(e) => setUsername(e.target.value)} className="mt-1.5 bg-[#0f0f10] border-[#2a2a2e] text-white" autoComplete="username" />
          </div>
          <div>
            <Label htmlFor="password" className="text-gray-300">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-[#0f0f10] border-[#2a2a2e] text-white" autoComplete="current-password" />
          </div>
          {error && <p className="text-sm text-[#e63946]">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-[#e63946] hover:bg-[#d12f3c] text-white">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
